export const DummyData = [
  {
    id: 1,
    type: 4,
    assignee: "Jerome Muller",
    from: null,
    timestamp: "2023-05-08T13:19:54.00",
    status: null,
    labels: null,
    isRead: false,
    isFollowing: true,
  },
  {
    id: 5,
    type: 5,
    assignee: "Jerome Muller",
    from: null,
    timestamp: "2023-05-08T13:19:54.00",
    status: null,
    labels: null,
    isRead: true,
    isFollowing: true,
  },
  {
    id: 2,
    type: 1,
    assignee: {
      name: "Max Jerif",
      id: 0,
      avatar: null,
    },
    from: {
      name: "Josh Smith",
      id: 1,
      avatar: "https://mui.com/static/images/avatar/2.jpg",
    },
    message: {
      id: 0,
      text: "hey i have assigned this lead to you kindly look forward hey i have assigned this lead to you kindly look forward",
      sender: {
        name: "Josh smith",
      },
    },
    status: {
      updatedBy: {
        name: "Josh Smith",
        id: 1,
      },
    },
    timestamp: "2023-05-08T13:19:54.00",
    labels: null,
    isRead: true,
    isFollowing: true,
  },
  {
    id: 3,
    type: 3,
    assignee: null,
    from: null,
    message: {
      id: 0,
      text: "hey i need to see a demo of sms opt-in and other junk text to be ellipses",
      sender: {
        name: "Josh smith",
      },
    },
    timestamp: "2023-05-08T13:19:54.00",
    status: null,
    labels: null,
    isRead: true,
  },
  {
    id: 4,
    type: 6,
    assignee: null,
    from: null,
    timestamp: "2023-05-08T13:19:54.00",
    status: null,
    labels: ["Failed"],
    isRead: true,
  },
];
